import { render, staticRenderFns } from "./BulletinInfo.vue?vue&type=template&id=5f52b678"
import script from "./BulletinInfo.vue?vue&type=script&lang=js"
export * from "./BulletinInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports